function toQueryString(query = {}) {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([k, v]) => {
    if (v !== '' && v !== undefined && v !== null) params.set(k, String(v));
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

function createCreditorActions({ apiFetch }) {
  const fetchCompanyCreditors = async (companyId, query = {}, fetchOptions = {}) =>
    apiFetch(`/api/companies/${companyId}/creditors${toQueryString(query)}`, fetchOptions);

  const fetchCompanyCreditorsKpis = async (companyId, fetchOptions = {}) =>
    apiFetch(`/api/companies/${companyId}/creditors/kpis`, fetchOptions);
  const fetchCreditorBankInformations = async (companyId, syncedCreditorRowId) => apiFetch(`/api/companies/${companyId}/creditors/${syncedCreditorRowId}/bank-informations`);
  const fetchCreditorAddressDetail = async (companyId, syncedCreditorRowId) => apiFetch(`/api/companies/${companyId}/creditors/${syncedCreditorRowId}/address-detail`);
  const fetchCreditorContactDetail = async (companyId, syncedCreditorRowId) => apiFetch(`/api/companies/${companyId}/creditors/${syncedCreditorRowId}/contact-detail`);

  const fetchCreditorPayments = async (companyId, syncedCreditorRowId, query = {}) =>
    apiFetch(`/api/companies/${companyId}/creditors/${syncedCreditorRowId}/payments${toQueryString(query)}`);

  const syncCompanyCreditorsTotal = async (companyId, body = {}) =>
    apiFetch(`/api/companies/${companyId}/creditors/sync-total`, {
      method: 'POST',
      body: JSON.stringify(body),
    });

  const fetchCompanyCreditorsSyncTotalStatus = async (companyId, fetchOptions = {}) =>
    apiFetch(`/api/companies/${companyId}/creditors/sync-total/status`, fetchOptions);
  const fetchCompanySyncLogs = async (companyId, query = {}, fetchOptions = {}) =>
    apiFetch(`/api/companies/${companyId}/sync-logs${toQueryString(query)}`, fetchOptions);
  const syncCompanyFieldsCompanies = async (companyId) =>
    apiFetch(`/api/companies/${companyId}/sync-fields/companies`, {
      method: 'POST',
    });
  const fetchCompanyFieldsCompanies = async (companyId, fetchOptions = {}) =>
    apiFetch(`/api/companies/${companyId}/sync-fields/companies`, fetchOptions);
  const syncCompanyFieldsCostCenters = async (companyId) =>
    apiFetch(`/api/companies/${companyId}/sync-fields/cost-centers`, {
      method: 'POST',
    });
  const fetchCompanyFieldsCostCenters = async (companyId, query = {}, fetchOptions = {}) =>
    apiFetch(`/api/companies/${companyId}/sync-fields/cost-centers${toQueryString(query)}`, fetchOptions);

  const deleteCreditor = async (companyId, creditorId) =>
    apiFetch(`/api/companies/${companyId}/creditors/${creditorId}`, { method: 'DELETE' });

  const saveCreditorFromSienge = async (companyId, body) =>
    apiFetch(`/api/companies/${companyId}/creditors/save-from-sienge`, {
      method: 'POST',
      body: JSON.stringify(body),
    });

  const syncCreditorPreferences = async (companyId) =>
    apiFetch(`/api/companies/${companyId}/creditors/sync-preferences`, { method: 'POST' });

  const fetchCreditorPreferences = async (companyId, creditorId) =>
    apiFetch(`/api/companies/${companyId}/creditors/${creditorId}/preferences`);

  const setCreditorPreferences = async (companyId, creditorId, body) =>
    apiFetch(`/api/companies/${companyId}/creditors/${creditorId}/preferences`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });

  return {
    fetchCompanyCreditors,
    fetchCompanyCreditorsKpis,
    fetchCreditorBankInformations,
    fetchCreditorAddressDetail,
    fetchCreditorContactDetail,
    fetchCreditorPayments,
    syncCompanyCreditorsTotal,
    fetchCompanyCreditorsSyncTotalStatus,
    fetchCompanySyncLogs,
    syncCompanyFieldsCompanies,
    syncCompanyFieldsCostCenters,
    fetchCompanyFieldsCompanies,
    fetchCompanyFieldsCostCenters,
    deleteCreditor,
    saveCreditorFromSienge,
    syncCreditorPreferences,
    fetchCreditorPreferences,
    setCreditorPreferences,
  };
}

export { createCreditorActions };
